import type { FaqCategory } from '../types/content';

export const faqCategories: FaqCategory[] = [
  {
    id: 'employers',
    label: 'Employers',
    items: [
      {
        q: 'How do we initiate a search with Corventa?',
        a: 'Submit an inquiry through our employer form or contact page. A consultant will arrange an initial conversation to understand the role, the context and your timeline, then propose an approach and engagement terms.',
      },
      {
        q: 'What types of roles do you cover?',
        a: 'We focus on board, C-suite, executive, senior management and specialist professional roles, on a permanent, interim or contract basis.',
      },
      {
        q: 'What engagement models do you offer?',
        a: 'Engagements are typically retained for executive and confidential searches, with options for exclusive permanent recruitment, interim placements, and advisory or market-mapping projects. Terms are agreed before work begins.',
      },
      {
        q: 'How long does a search usually take?',
        a: 'Timelines depend on the role, the market and stakeholder availability. We agree a realistic timetable at the outset and update you at each milestone.',
      },
    ],
  },
  {
    id: 'candidates',
    label: 'Candidates',
    items: [
      {
        q: 'How do I register with Corventa?',
        a: 'Use the confidential registration form on our Candidates page. You can share your CV, preferences and the level of confidentiality you require.',
      },
      {
        q: 'What happens after I apply for a role?',
        a: 'A consultant reviews your application against the brief. If there is a potential match, they will contact you to discuss the opportunity in more detail. We aim to acknowledge every application, although we cannot guarantee an interview.',
      },
      {
        q: 'Will my current employer know I am exploring opportunities?',
        a: 'No. We never share your details with any organisation without your explicit permission for each specific opportunity.',
      },
      {
        q: 'How will you communicate with me?',
        a: 'By the channels you choose — typically email and phone. You can update your preferences or ask us to delete your information at any time.',
      },
    ],
  },
  {
    id: 'executive-search',
    label: 'Executive Search',
    items: [
      {
        q: 'What makes executive search different from recruitment?',
        a: 'Executive search is proactive and research-led. Rather than relying on applicants, we map the market and approach leaders directly, including those who are not actively looking.',
      },
      {
        q: 'Can a search be conducted confidentially?',
        a: 'Yes. Confidential searches can run under a code name, with controlled disclosure of the organisation’s identity and non-disclosure arrangements where appropriate.',
      },
      {
        q: 'How are candidates assessed?',
        a: 'Against a success profile agreed with you at the outset, using structured interviews, competency assessment and, where appropriate, referencing and due diligence.',
      },
    ],
  },
  {
    id: 'process',
    label: 'Recruitment Process',
    items: [
      {
        q: 'How does the recruitment process work?',
        a: 'Our process moves from discovery and briefing through research, outreach, assessment and shortlisting to interviews, offer coordination and appointment. The full methodology is explained on our Search Process page.',
      },
      {
        q: 'Do you conduct references and background checks?',
        a: 'Where appropriate and with the candidate’s consent, we coordinate references and due diligence before an offer is finalised.',
      },
      {
        q: 'Do you provide support after an appointment?',
        a: 'Where it is included in the engagement, we stay in touch with both the client and the appointee during the first months of the role.',
      },
    ],
  },
];
